// ops — контрольный центр (Mini App владельца в TG-боте)
import { z } from 'zod';

export const OpsStatusReqSchema = z.object({
  initData: z.string().min(1).max(4096),
});
export type OpsStatusReq = z.infer<typeof OpsStatusReqSchema>;

export const OpsRowSchema = z.object({
  name: z.string(),
  label: z.string(),
  kind: z.enum(['worker', 'pages']),
  deployed_at: z.string().nullable(),
  author: z.string().nullable(),
  branch: z.string().nullable(),
  commit: z.string().nullable(),
  health: z.enum(['ok', 'fail', 'skip']),
  url: z.string().nullable(),
});
export type OpsRow = z.infer<typeof OpsRowSchema>;

export const OpsStatusResSchema = z.object({
  generated_at: z.string(),
  workers: z.array(OpsRowSchema),
  pages: z.array(OpsRowSchema),
});
export type OpsStatusRes = z.infer<typeof OpsStatusResSchema>;

export const OpsActivityUserSchema = z.object({
  actor: z.string(),
  surfaces: z.string(),
  events: z.number(),
  sessions: z.number(),
  opens: z.number(),
  captures: z.number(),
  downloads: z.number(),
  errors: z.number(),
  first_at: z.string(),
  last_at: z.string(),
});
export const OpsActivityResSchema = z.object({
  day_start: z.string(),
  totals: z.object({ users: z.number(), events: z.number(), captures: z.number() }),
  users: z.array(OpsActivityUserSchema),
});
export type OpsActivityRes = z.infer<typeof OpsActivityResSchema>;

export const OpsErrorRowSchema = z.object({
  at: z.string(),
  event: z.string(),
  path: z.string(),
  status: z.number().nullable(),
  actor: z.string(),
});
export const OpsErrorsResSchema = z.object({
  days: z.array(z.object({ d: z.string(), n: z.number() })),
  recent: z.array(OpsErrorRowSchema),
});
export type OpsErrorsRes = z.infer<typeof OpsErrorsResSchema>;

export const OpsRollbackReqSchema = z.object({
  initData: z.string().min(1).max(4096),
  kind: z.enum(['worker', 'pages']),
  name: z.string().regex(/^[a-z0-9][a-z0-9-]{1,60}$/),
});
export type OpsRollbackReq = z.infer<typeof OpsRollbackReqSchema>;
export const OpsRollbackResSchema = z.object({
  ok: z.boolean(),
  detail: z.string(),
});
export type OpsRollbackRes = z.infer<typeof OpsRollbackResSchema>;
